import subDays from "date-fns/subDays";
import RegionIcon from "../svgs/map_region.svg";
import CalenderIcon from "../svgs/event_calendar.svg";
const get_years = () => {
  var getCurrentYear = new Date().getFullYear();
  var listOfYears = Array.from({ length: 6 }, (_, i) => ({
    name: getCurrentYear - i,
    id: getCurrentYear - i,
  }));

  return listOfYears;
};
const report_types = [
  { id: "region_wise", name: "Region wise" },
  { id: "area_wise", name: "Area wise" },
  { id: "territory_wise", name: "Territory wise" },
  { id: "agency_wise", name: "Agency wise" },
  { id: "ff_wise", name: "Field-force wise" },
  { id: "merchant_wise", name: "Merchant wise" },
];

const report_types_route_target_vs_achivement = [
  { id: "ff_wise", name: "Field-force wise" },
  { id: "route_wise", name: "Route wise" },
];

const acquisition_report_types = [
  { id: "detail-acquisition-report", name: "Merchant wise" },
  { id: "circle-wise-acquisition-report", name: "Circle wise" },
  { id: "zone-wise-acquisition-report", name: "Zone wise" },
  { id: "territory-wise-acquisition-report", name: "Territory wise" },
  { id: "distributor-wise-acquisition-report", name: "Distributor wise" },
  // { id: "serving-emp-wise-acquisition-report", name: "Serving employee wise" },
  // {
  //   id: "acquiring-emp-wise-acquisition-report",
  //   name: "Acquiring employee wise",
  // },
];

const filter_whitelist_detailed_acquisition = {
  "": ["acquisition_report_type", "year", "month"],

  "detail-acquisition-report": ["acquisition_report_type", "year", "month"],
  "circle-wise-acquisition-report": [
    "acquisition_report_type",
    "year",
    "month",
    "region",
  ],
  "zone-wise-acquisition-report": [
    "acquisition_report_type",
    "year",
    "month",
    "region",
    "area",
  ],
  "territory-wise-acquisition-report": [
    "acquisition_report_type",
    "year",
    "month",
    "region",
    "area",
    "territory",
  ],
  "distributor-wise-acquisition-report": [
    "acquisition_report_type",
    "year",
    "month",
    "region",
    "area",
    "territory",
    "agency",
  ],
  "serving-emp-wise-acquisition-report": [
    "acquisition_report_type",
    "year",
    "month",
    "region",
    "area",
    "territory",
    "agency",
  ],
  "acquiring-emp-wise-acquisition-report": [
    "acquisition_report_type",
    "year",
    "month",
    "region",
    "area",
    "territory",
    "agency",
  ],
};

const months = [
  {
    name: "January",
    id: "01",
  },
  {
    id: "02",
    name: "February",
  },
  {
    id: "03",
    name: "March",
  },
  {
    id: "04",
    name: "April",
  },
  {
    id: "05",
    name: "May",
  },
  {
    id: "06",
    name: "June",
  },
  {
    id: "07",
    name: "July",
  },
  {
    id: "08",
    name: "August",
  },
  {
    id: "09",
    name: "September",
  },
  {
    id: "10",
    name: "October",
  },
  {
    id: "11",
    name: "November",
  },
  {
    id: "12",
    name: "December",
  },
];
const get_months = (last_number_of_month) => {
  var today = new Date();
  var d;
  var lastMonthList = [];
  var months = [...Array(12).keys()].map((key) => ({
    id: String(key + 1).padStart(2, "0"),
    name: new Date(0, key).toLocaleString("en", { month: "long" }),
  }));
  for (var i = last_number_of_month - 1; i >= 0; i -= 1) {
    d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    lastMonthList.push(months[d.getMonth()]);
  }
  return lastMonthList.reverse();
};

const report_tabs = [
  "merchant_performance", // group 1
  "acquisition_performance", // group 2
  "visit_performance", //... 3
  "attendance", //...4
  "mapping", //...5
  "dump_files", //...6
  "categorization", //...7
  "payment_speaker", //...8
  "target_vs_achievement", //... 9
  "discontinued", //...10
  "all",
];

const upload_tabs = [
  "Information",
  "Entity",
  "Mapping",
  "Targets",
  "Discontinued",
  //"Inventory",
  "Campaign",
  "Payment Speaker",
  "all",
];

const filter_whitelist = [
  "year",
  "month",
  "report_type",
  "report_type_route_target_vs_achivement",
  "business_unit",
  "sub_unit",
  "transaction_date",
  "regions",
  "areas",
  "territories",
  "agency",
  "field_force",
  "reg_start_date",
  "reg_end_date",
  "status",
];
const merchant_status = [
  { id: "ACTIVE", name: "Active" },
  { id: "INACTIVE", name: "Inactive" },
  { id: "DISCONTINUED", name: "Discontinued" },
];

const employee_types = [
  { id: "MAO", name: "MAO" },
  { id: "MMO", name: "MMO" },
  { id: "MDO", name: "MDO" },
];
const filter_config_ordered_keys = [
  "year",
  "month",
  "date",
  "report_type",
  "report_type_route_target_vs_achivement",
  "business_unit",
  "sub_unit",
  "acquisition_report_type",
  "transaction_date",
  "region",
  "area",
  "territory",
  "agency",
  "field_force",
  "reg_start_date",
  "reg_end_date",
  "start_time",
  "end_time",
  "status",
];
const filter_config = {
  year: {
    label: "Year",
    key: "year",
    options: get_years(),
    value: "",
    category: "date_filter",
    icon: RegionIcon,
  },
  month: {
    label: "Month",
    key: "month",
    options: get_months(6),
    value: "",
    category: "date_filter",
    icon: RegionIcon,
  },
  date: {
    label: "Date",
    key: "date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: subDays(new Date(), 1),
    category: "date_filter",
    icon: CalenderIcon,
  },
  report_type: {
    label: "Report type",
    key: "report_type",
    options: report_types,
    value: "",
    category: "type_filter",
    icon: RegionIcon,
  },
  report_type_route_target_vs_achivement: {
    label: "Report type",
    key: "report_type_route_target_vs_achivement",
    options: report_types_route_target_vs_achivement,
    value: "",
    category: "type_filter",
    icon: RegionIcon,
  },
  business_unit: {
    label: "Business unit",
    key: "business_unit",
    options: [],
    paramTag: "business_unit",
    type: "multi-select",
    value: [],
    category: "category_filter",
  },
  sub_unit: {
    label: "Business sub-unit",
    key: "sub_unit",
    options: [],
    paramTag: "sub_unit",
    type: "multi-select",
    value: [],
    category: "category_filter",
  },
  acquisition_report_type: {
    label: "Report type",
    key: "acquisition_report_type",
    options: acquisition_report_types,
    value: "",
    category: "type_filter",
    icon: RegionIcon,
  },
  transaction_date: {
    label: "Transaction date",
    key: "transaction_date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },

  region: {
    label: "Circle",
    key: "region",
    options: [],
    paramTag: "region",
    childKey: "area",
    childApiPoint: "organizations/api/v1/areas",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: RegionIcon,
  },
  area: {
    label: "Zone",
    key: "area",
    options: [],
    //disabledLabel: "Select an region first",
    paramTag: "area",
    childKey: "territory",
    childApiPoint: "organizations/api/v1/territories",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: RegionIcon,
  },
  territory: {
    label: "Territory",
    key: "territory",
    options: [],
    // disabledLabel: "Select an area first",
    paramTag: "territory",
    childKey: "agency",
    childApiPoint: "organizations/api/v1/agency",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: RegionIcon,
  },
  agency: {
    label: "Distributor",
    key: "agency",
    options: [],
    //disabledLabel: "Select an territory first",
    childKey: "field_force",
    childApiPoint: "admin_panel/v1/mdo-list",
    paramTag: "agency",
    type: "multi-select",
    value: [],
    category: "entity_filter",
    icon: RegionIcon,
  },

  field_force: {
    label: "Field-force",
    key: "field_force",
    options: [],
    category: "entity_filter",

    //disabledLabel: "Select an territory first",
    type: "multi-select",
    value: [],
    icon: RegionIcon,
  },
  team: {
    label: "Employee type",
    key: "team",
    options: employee_types,
    category: "entity_filter",

    //disabledLabel: "Select an territory first",
    type: "multi-select",
    value: [],
    icon: RegionIcon,
  },
  reg_start_date: {
    label: "Registration start date",
    key: "reg_start_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },
  reg_end_date: {
    label: "Registration end date",
    key: "reg_end_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },
  start_time: {
    label: "Start date",
    key: "start_time",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },
  end_time: {
    label: "End date",
    key: "end_time",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },
  status: {
    label: "Merchant status",
    key: "status",
    options: merchant_status,
    type: "multi-select",
    //disabledLabel: "Select an territory first",
    value: [],
    category: "type_filter",
    icon: RegionIcon,
  },
};

const categorization_filter_whitelist = [
  "reg_start_date",
  "reg_end_date",
  "business_unit",
  "sub_unit",
  "regions",
  "areas",
  "status",
];

const filter_whitelist_merchant = {
  "": [
    "report_type",
    "transaction_date",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],

  region_wise: [
    "report_type",
    "transaction_date",

    "region",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  area_wise: [
    "report_type",
    "transaction_date",

    "region",
    "area",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  territory_wise: [
    "report_type",
    "transaction_date",

    "region",
    "area",
    "territory",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  agency_wise: [
    "report_type",
    "transaction_date",

    "region",
    "area",
    "territory",
    "agency",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  ff_wise: [
    "report_type",
    "transaction_date",

    "region",
    "area",
    "territory",
    "agency",
    "field_force",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  merchant_wise: [
    "report_type",
    "transaction_date",

    "region",
    "area",
    "territory",
    "agency",
    "field_force",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
};

export {
  filter_config,
  filter_whitelist,
  report_tabs,
  upload_tabs,
  filter_config_ordered_keys,
  filter_whitelist_merchant,
  filter_whitelist_detailed_acquisition,
};
